// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"291":"9751446e","566":"214dc5dc","594":"b091ebda","927":"4bdf168d"}[chunkId] + ".chunk.js";
};